// Copyright © 2019-2026 Focal Systems. All rights reserved.

/**
 * The page an authenticated user lands on by default — used for the bare-root
 * redirect, the post-login fallback, and to decide when a `?redirect` param on
 * the login URL is redundant (it points at this page with no query anyway).
 *
 * TODO: switch this to `/home` once the Home page is implemented — it becomes
 * the default authenticated landing page. Update this single constant and the
 * bare-root redirect / login fallback / login `?redirect` skipping all follow.
 */
export const DEFAULT_AUTHENTICATED_PATH = "/chains" as const;
